import { FormType } from '..'
import { ImageForm } from '../../GuidedIntro/components/profile/ImageForm'
import { LocationForm } from '../../GuidedIntro/components/profile/LocationForm'
import { ProfileForm } from '../../GuidedIntro/components/profile/ProfileForm'
import { ProfileSteps } from '../../GuidedIntro/components/profile/ProfileStep'
import { SocialForm } from '../../GuidedIntro/components/profile/SocialForm'
import { TopicForm } from '../../GuidedIntro/components/topics/TopicForm'

// Re-instate subscriptions: uncomment import and case below
// import { SubscriptionStep } from '../../GuidedIntro/components/subscriptions/SubscriptionStep'
import { useTopics } from '@/hooks/useTopics'
import { User } from '@/payload-types'

import { DashboardForm } from './DashboardForm'
import { PasswordForm } from './PasswordForm'

export const RenderForm = ({
  formType,
  user,
  setOpenDrawer,
  setCurrentProfileStep,
  onUserUpdated,
  currentProfileStep,
}: {
  formType: FormType
  user: User
  setOpenDrawer: (open: boolean) => void
  setCurrentProfileStep: (step: ProfileSteps) => void
  onUserUpdated?: (updatedUser?: User) => Promise<void>
  currentProfileStep?: ProfileSteps
}) => {
  const { topics, loading } = useTopics('bills')
  switch (formType) {
    case 'profile':
      return (
        <ProfileForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          currentProfileStep={currentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
    case 'image':
      return (
        <ImageForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
    case 'socials':
      return (
        <SocialForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
    case 'location':
      return (
        <LocationForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
    case 'password':
      return <PasswordForm />
    case 'topics':
      return loading ? (
        <div>Loading topics...</div>
      ) : (
        <div className="m-auto max-w-2xl">
          <h2 className="p-4 text-center font-family-display text-2xl xl:text-4xl">
            Select or update the topics you&apos;re interested in
          </h2>
          <TopicForm topics={topics} user={user} onUserUpdated={onUserUpdated} />
        </div>
      )
    case 'dashboard':
      return <DashboardForm />
    // Re-instate subscriptions: uncomment case and add 'subscriptions' to FormType in Settings/index
    // case 'subscriptions':
    //   return <SubscriptionStep user={user} onUserUpdated={onUserUpdated} />
  }
}
